import { render, staticRenderFns } from "./ComponentAuthGuard.vue?vue&type=template&id=04f41e0e&"
import script from "./ComponentAuthGuard.vue?vue&type=script&lang=ts&"
export * from "./ComponentAuthGuard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports